module.exports = __webpack_public_path__ + "img/search.0ab82ab4.svg";